import { render, staticRenderFns } from "./normalGraph.vue?vue&type=template&id=33a85f6e&scoped=true"
import script from "./normalGraph.vue?vue&type=script&lang=js"
export * from "./normalGraph.vue?vue&type=script&lang=js"
import style0 from "./normalGraph.vue?vue&type=style&index=0&id=33a85f6e&prod&lang=scss&scoped=true"
import style1 from "./normalGraph.vue?vue&type=style&index=1&id=33a85f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a85f6e",
  null
  
)

export default component.exports